import { render } from "./UserCardsList.vue?vue&type=template&id=6c8b2f66&scoped=true"
import script from "./UserCardsList.vue?vue&type=script&lang=js"
export * from "./UserCardsList.vue?vue&type=script&lang=js"

import "./UserCardsList.vue?vue&type=style&index=0&id=6c8b2f66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8b2f66"]])

export default __exports__